import ScrollToTop from "@/components/base/ScrollToTop";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotArticles from "./components/HotArticles";
import LatestArticles from "./components/LatestArticles";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const websiteSchema = {
    url: "https://91shequ.com",
    name: "91社区",
    description:
      "91社区是国内人气超高的综合性内容平台，汇聚海量优质资源与活跃用户群体，提供流畅的浏览体验、多元化内容分类与便捷的互动功能。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://91shequ.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const faqPageSchema = {
    mainEntity: [
      {
        "@type": "Question",
        name: "91社区是什么？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "91社区是国内领先的综合性内容平台，汇聚了科技数码、生活娱乐、学习教育、游戏动漫、影视音乐、健康养生等六大领域的优质内容。",
        },
      },
      {
        "@type": "Question",
        name: "91社区是否有手机版？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "是的！91社区提供完善的移动端体验，您可以通过手机浏览器直接访问，也可以在各大应用商店搜索「91社区」下载iOS和Android客户端。",
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="FAQPage" data={faqPageSchema} />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "91社区 - 首页",
          description:
            "91社区是国内人气超高的综合性内容平台，汇聚海量优质资源与活跃用户群体。",
          url: "https://91shequ.com",
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotArticles />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}